import { EditOutlined, EyeInvisibleOutlined, LogoutOutlined, TeamOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { screenWidths } from '../../../enums';
import { useClickedOutside, useMedia } from '../../../hooks';
import authService from '../../../services/auth.service';
import { disableScroll, enableScroll } from '../../../utils/enable-disable-scroll';

const Menu = styled.div`
	position: relative;
`;

const DropdownCloseIcon = styled.span`
	position: fixed;
	top: 10px;
	left: 30px;
	font-size: 40px;
`;

const MenuContent = styled.div<{ media: keyof typeof screenWidths }>`
	background-color: #fff;
	box-sizing: border-box;
	// padding: 5px 0;
	transition: all 0.2s;
	border: 1px solid rgb(224, 224, 224);
	position: fixed;
	height: 100vh;
	width: 100vw;
	z-index: 300;
	top: 0;
	left: 0;
	margin: 0;
	transform-origin: center;
	border-radius: 0;

	display: flex;
	justify-content: center;
	align-items: center;
	ul {
		width: 100%;
	}
	li {
		display: flex;
		align-items: center;
		color: rgba(0, 0, 0, 0.65);
		line-height: 22px;
		// padding: 5px 15px;
		transition: all 0.3s;
		margin-top: 20px;
		font-size: 20px;
		width: 100%;

		a {
			color: rgba(0, 0, 0, 0.65);
			font-size: 20px;
		}
		i,
		span {
			padding: 5px;
			margin-right: 20px;
		}
	}
	li:hover,
	li:active {
		background-color: rgba(0, 0, 0, 0.05);
	}

	&.open {
		transform: scale(1);
	}

	&.closed {
		transform: scale(0);
	}

	.dropdownList {
		list-style: none;
		padding: 0;
		margin: 0;
		text-align: left;
	}

	@media (min-width: ${({ media }) => screenWidths[media]}) {
		position: absolute;

		width: 180px;
		height: auto;
		top: 5px;
		right: -10px;
		margin-top: 5px;
		transform-origin: top;
		border-radius: 5px;

		li {
			margin: 3px 0;
			font-size: 16px;

			a {
				font-size: 16px;
			}
		}

		i,
		span {
			margin-right: 20px;
		}
	}
`;

const Dropdown = ({ backOffice, media, children }) => {
	let view = useMedia(media);
	const { ref, isComponentVisible, setIsComponentVisible } = useClickedOutside(false);
	const dropdownHandler = () => {
		setIsComponentVisible(!isComponentVisible);
		if (!view) {
			disableScroll();
		}
	};

	const dropdownClose = () => {
		setIsComponentVisible(false);
		enableScroll();
	};

	useEffect(() => {
		dropdownClose();
	}, [useLocation().pathname]);

	const menu = (
		<MenuContent className={isComponentVisible ? 'open' : 'closed'} media={media}>
			<ul className="dropdownList">
				<li key="2">
					<EditOutlined className="me-1" />
					<Link to="/dashboard/profile/edit">View Profile</Link>
				</li>
				<li key="3">
					<EyeInvisibleOutlined className="me-1" />
					<Link to="/change-password">Change Password</Link>
				</li>

				{backOffice ? null : (
					<li key="3">
						<TeamOutlined className="me-1" />
						<Link to="/dashboard/company/team">Team Members</Link>
					</li>
				)}

				<li
					key="4"
					onClick={() => {
						authService.logout();
						window.location.reload();
					}}
				>
					<LogoutOutlined className="me-1" />
					<span>Logout</span>
				</li>
			</ul>
			{view ? null : <DropdownCloseIcon onClick={dropdownClose}>&times;</DropdownCloseIcon>}
		</MenuContent>
	);
	return (
		<div ref={ref} style={{ minWidth: useMedia(media) ? '160px' : 'auto' }}>
			<div onClick={dropdownHandler}>{children}</div>
			<Menu>{menu}</Menu>
		</div>
	);
};

export default Dropdown;
